
import Home from './home/Home';
import Result from './result/Result';
import Loader from './loader/Loader'
import FallBack from './fallback/FallBack';

export default {
    Loader,
    Home,
    Result,
    FallBack
}